// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-module__tooltip___IwdrI"};